/**
 * The room's recommendation (recipient journey R9.4): her own typed line may
 * fit another Mystic's practice better; the server answers with one line,
 * the Mystic's name its only link. It no longer moves anything into the bar
 * (navigation-design 2026-10-25: the bar is the server's `nav`).
 */

/** The room's message for the recommendation the server returned, or null. */
export function recommendationMessage (rec) {
  if (!rec || !rec.line || !rec.sub_domain) return null
  return { text: rec.line, type: 'reader', _context: 'recommendation', reader_link: rec.link || rec.name || '',
           reader_sub: rec.sub_domain }
}

/** Her typed line is worth asking about: a few words, not a tap. */
export function worthAsking (text) {
  return (String(text || '').trim().split(/\s+/).filter(Boolean).length) >= 3
}

/**
 * When another Mystic is suggested (recipient polish 2026-11-03, DESIGN §8d;
 * BE-CONTRACT §3): at the end of a reading, after "What landed?" and the
 * kept line, only once the Community is open, once a session. Never
 * mid-interview, before the Community exists.
 */
export function suggestionDue ({ communityOpen = false, said = false, asking = false } = {}) {
  return !!communityOpen && !said && !asking
}
